var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3041_15563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58 1.50023H6C4.82016 1.48822 3.68373 1.94475 2.84009 2.76965C1.99645 3.59454 1.51451 4.72041 1.5 5.90023V58.1102C1.51713 59.2883 2.00023 60.4116 2.84359 61.2344C3.68694 62.0571 4.82187 62.5123 6 62.5002H58C59.1799 62.5096 60.3156 62.0515 61.1588 61.2261C62.002 60.4007 62.4842 59.2751 62.5 58.0952V5.88523C62.479 4.70887 61.9945 3.58837 61.1518 2.76726C60.3092 1.94615 59.1765 1.49082 58 1.50023Z",
    fill: "#0076B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5301 24.3652H19.5851V53.5002H10.5301V24.3652ZM15.0601 9.86523C16.0986 9.86523 17.1139 10.1733 17.9773 10.7504C18.8408 11.3275 19.5137 12.1477 19.9109 13.1073C20.3081 14.0669 20.4118 15.1228 20.2088 16.1413C20.0058 17.1598 19.5053 18.0953 18.7706 18.8293C18.0359 19.5633 17.0999 20.063 16.0812 20.265C15.0625 20.467 14.0067 20.3623 13.0475 19.9642C12.0883 19.566 11.2687 18.8924 10.6924 18.0283C10.1161 17.1643 9.80907 16.1488 9.81006 15.1102C9.81139 13.7187 10.3651 12.3846 11.3495 11.4012C12.3339 10.4177 13.6685 9.86523 15.0601 9.86523ZM25.2651 24.3652H33.9451V28.3652H34.0651C35.2751 26.0752 38.2251 23.6602 42.6301 23.6602C51.8001 23.6402 53.5001 29.6752 53.5001 37.5002V53.5002H44.4451V39.3252C44.4451 35.9502 44.3851 31.6052 39.7401 31.6052C35.0951 31.6052 34.3051 35.2852 34.3051 39.1052V53.5002H25.2651V24.3652Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3041_15563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "scale(2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.d9f46226cd8eb8385940310f7250a0f7.svg";
export { ForwardRef as ReactComponent };